import { COU_httpGet, COU_httpPost } from "@/utils/http"

export async function deleteProduct(data) {
  const url = "/marketProduct/deleteProduct"
  const r = await COU_httpPost({ url, data: data })
  let msg = "",
    success = false,
    result = {}
  try {
    msg = r.msg
    success = r.success
    result = r.result
    //  result.Data = result.Datas;
  } catch (error) {
    console.log(error)
  }
  return { success, msg, result }
}
export async function getProductList(data) {
  const url = "/marketProduct/productList"
  const r = await COU_httpGet({ url, data: data })
  let msg = "",
    success = false,
    result = {}
  try {
    msg = r.msg
    success = r.success
    result = r.result
    //  result.Data = result.Datas;
  } catch (error) {
    console.log(error)
  }
  return { success, msg, result }
}
export async function getProductInfo(data) {
  const url = "/marketProduct/productInfo"
  const r = await COU_httpGet({ url, data: data })
  let msg = "",
    success = false,
    result = {}
  try {
    msg = r.msg
    success = r.success
    result = r.result
    //  result.Data = result.Datas;
  } catch (error) {
    console.log(error)
  }
  return { success, msg, result }
}

// 修改商品库存、价格
export async function marketProductEdit(data) {
  const url = "/marketProduct/edit"
  const r = await COU_httpPost({ url, data: data })
  let msg = "",
    success = false,
    result = {}
  try {
    msg = r.msg
    success = r.success
    result = r.result
  } catch (error) {
    console.log(error)
  }
  return { success, msg, result }
}
